An array of SEEK work arrangement codes.

Currently, three codes are defined:

- `Hybrid` indicates a hybrid position.
- `OnSite` indicates an on-site position.
- `Remote` indicates a remote position.

This field is limited to a single element.
